import React, { useEffect, useState, useRef } from "react";
import "./dilemma.css";
import { useParams, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import upAr from "../../images/up-arrow.svg";
import PressureGauge from "../PressureGauge/PressureGauge";
import loadimg from "../../images/pp-logo.gif";
import DilemaPop from "../DilemaPop/DilemaPop";

function Dilemma({ token ,slug}) {
  const navigate = useNavigate();
  // const { slug } = useParams();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, []);

  const [showPopup, setShowPopup] = useState(true);

  const [testData, setTestData] = useState({});

  const [DilemmaPopup, setDilemmaPopup] = useState({});

  const [questions, setQuestions] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentQuestion = questions[currentIndex];

  const [answers, setAnswers] = useState({});
  const [selected, setSelected] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [pressureData, setPressureData] = useState({});

  const [isToggled, setIsToggled] = useState(false);
  const MAX_TIME = 100;
  const [elapsed, setElapsed] = useState(0);

  const progress = Math.min(100, Math.round((elapsed / MAX_TIME) * 100));

  const [bgLoaded, setBgLoaded] = useState(false);

  const zoneLabel =
    progress <= 30
      ? "Cool-headed"
      : progress <= 60
        ? "Steady"
        : progress <= 80
          ? "Heated"
          : "Overdrive";

  const showFlame = progress > 60;

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  const [streak, setStreak] = useState(0);

  const answeredQuestions = useRef(new Set());
  const overdrivePenaltyApplied = useRef(new Set());

  const applyZoneStreak = () => {
    const questionId = currentQuestion.id;

    if (answeredQuestions.current.has(questionId)) return;

    if (progress <= 60) {
      setStreak((s) => s + 1);
    }
    answeredQuestions.current.add(questionId);
  };

  useEffect(() => {

    if (showPopup) return;

    setElapsed(0);

    const timer = setInterval(() => {
      setElapsed((prev) => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [currentIndex,showPopup]);

  const overdriveTriggered = useRef(false);

  useEffect(() => {
    overdriveTriggered.current = false;
  }, [currentIndex]);

  useEffect(() => {
    if (progress > 80 && !overdriveTriggered.current) {
      setStreak((prev) => Math.max(0, prev - 1));
      overdriveTriggered.current = true;
    }
  }, [progress]);

  useEffect(() => {
    const fetchTest = async () => {
      try {
        const res = await axios.get(`${END_URL}/fetch/dilemma/${slug}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        setTestData(res.data.test);
        setQuestions(res.data.questions);
        setDilemmaPopup(res?.data?.dilemma_popup_content);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTest();
  }, [slug]);

  useEffect(() => {
    if (currentQuestion && answers[currentQuestion.id])
      setSelected(answers[currentQuestion.id]);
    else setSelected(null);
  }, [currentIndex, questions]);

  const handleNext = () => {
    if (selected === null) return;

    applyZoneStreak();

    const questionId = currentQuestion.id;

    setPressureData((prev) => ({
      ...prev,
      [questionId]: progress,
    }));

    const isLast = currentIndex === questions.length - 1;

    if (isLast) {
      submitQuiz();
      return;
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setCurrentIndex((i) => i + 1);
  };

  const handlePrev = () => {
    if (currentIndex === 0) return;
    setCurrentIndex((i) => i - 1);
  };

  const submitQuiz = async () => {
    try {
      setIsSubmitting(true);

      const res = await axios.post(
        `${END_URL}/submit/dilemma`,
        { test_id: testData.id, answers, pressures: pressureData },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      if (res.data.login) {
        if (res.data.sub) {
          navigate(`/result/dilemma/${res.data.result_slug}`);
        } else {
          navigate(`/dilemma-result/${res.data.result_slug}`);
        }
      }

      if (res.data.store_local) {
        localStorage.setItem(
          "guest_dilemma_result",
          JSON.stringify({
            test_id: testData.id,
            answers: answers,
            pressures: pressureData,
            result_slug: res.data.result_slug,
          }),
        );

        navigate(`/dilemma-result-log/${res.data.result_slug}`);
      }
    } catch (err) {
      alert("Submission failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!testData?.test_detail?.test_banner) return;

    const img = new Image();
    img.src = `${IMG_URL}/d0/${testData.test_detail.test_banner}`;

    img.onload = () => setBgLoaded(true);
    img.onerror = () => setBgLoaded(true);
  }, [testData]);

  if (!bgLoaded) {
    return (
      <div className="loader-container">
        <img src={loadimg} alt="Loading..." className="loader-gif" />
      </div>
    );
  }

  const remaining = questions.length - (currentIndex + 1);

  const template =
    DilemmaPopup?.dilemma_question_text ||
    "Answer to continue {question_no} questions";

  const finalText = template
    .replace("{question_no}", remaining)
    .replace("questions", remaining > 1 ? "questions" : "question");


  return (
    <div className="test-main1">
      <div
        className="hero"
        style={{
          background: `url(${IMG_URL}/d0/${testData?.test_detail?.test_banner})no-repeat center / cover`,
        }}
      >
        <div className="hero-content">
          <div className="common-title-desc">
            <h1>{testData?.name}</h1>

            <div
              dangerouslySetInnerHTML={{
                __html: testData?.test_detail?.short_description,
              }}
            />
          </div>

          <div className="content-grid">
            <div className="progress-speedomter">
              <div className="progress-pill">
                {/* Question {currentIndex + 1} / {questions.length} */}

                <div className="progress-inner">
                  <div className="progress-contents">
                    {currentQuestion && (
                      <span>{currentQuestion?.action?.name}</span>
                    )}
                    <span>
                      Question {currentIndex + 1} of {questions.length}
                    </span>
                  </div>
                  <div className="progress-btns">

                    <button className={`time-btn ${
                          progress > DilemmaPopup?.dilemma_end_time
                            ? "time-end"
                            : progress > DilemmaPopup?.dilemma_warning_time
                            ? "warning-time"
                            : ""
                        }`}
                      >

                      <span>⚡</span> <span>{formatTime(elapsed)}</span>

                    </button>

                    <button>
                      {" "}
                      <span>
                        {currentIndex + 1}/{questions.length}
                      </span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="pressure-card">

                <div className="pressure-title">
                  <span>▶</span>
                  <span>{DilemmaPopup?.dilemma_pressure_title}</span>{" "}
                  <span>
                    <img src={upAr} alt="" />
                  </span>
                </div>

                <div className="pressure-gauge-container">
                  <PressureGauge
                    value={progress}
                    zoneLabel={zoneLabel}
                    showFlame={progress > 60}
                    testData={testData}
                  />
                </div>

                <div className="zone-container">
                  <span>{zoneLabel}</span>
                </div>

                <div className="heat-label">
                  <span>{streak > 0 && `+${streak}`} Instinct Streak</span>

                  <div className="toggle-container">
                    <input
                      type="checkbox"
                      id="heat-toggle"
                      className="toggle-input"
                      checked={isToggled}
                      onChange={() => setIsToggled(!isToggled)}
                    />
                    <label htmlFor="heat-toggle" className="toggle-track">
                      <span className="toggle-thumb"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="question-card">
          
              <div className="question-card-ques">
                {currentQuestion && (
                  <>
                    <h2>{currentIndex+1} {")"} {currentQuestion.title}</h2>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: currentQuestion.description,
                      }}
                    />
                  </>
                )}

                <div className="options">
                  {currentQuestion?.options?.map((opt) => (
                    <div
                      key={opt.id}
                      className={`option ${selected === opt.id ? "active" : ""}`}
                      onClick={() => {
                        setSelected(opt.id);
                        setAnswers((prev) => ({
                          ...prev,
                          [currentQuestion.id]: opt.id,
                        }));
                      }}
                    >
                      <div className="option-badge">
                        <span>{opt.option_label}</span>
                      </div>

                      {opt.option_image && (
                        <div className="image-option">
                          <img
                            src={`${IMG_URL}/d0/${opt.option_image}`}
                            style={{ width: "100%" }}
                          />
                        </div>
                      )}

                      <div
                        className="option-text"
                        dangerouslySetInnerHTML={{ __html: opt.option_text }}
                      />
                    </div>
                  ))}
                </div>
              </div>
        <div className="continue-bar">
            <div className="continue-bar-btn">
              <a
                className="new-commom-btn new-commom-btn-left-ar continue-btn"
                onClick={handlePrev}
                disabled={currentIndex === 0}
              >
                <>
                  <span>Previous</span>{" "}
                  <span class="righ-arr">
                    {" "}
                    <FontAwesomeIcon icon={faArrowLeft} />{" "}
                  </span>
                </>
              </a>

              <span>
                  {finalText}
              </span>
              <a
                onClick={handleNext}
                disabled={selected === null || isSubmitting}
                className="continue-btn new-commom-btn"
              >
                {currentIndex === questions.length - 1 ? (
                  isSubmitting ? (
                    <>
                      <span>Submitting...</span>{" "}
                      <span class="righ-arr">
                        {" "}
                        <FontAwesomeIcon icon={faArrowRight} />{" "}
                      </span>
                    </>
                  ) : (
                    <>
                      <span>Finish</span>{" "}
                      <span class="righ-arr">
                        {" "}
                        <FontAwesomeIcon icon={faArrowRight} />{" "}
                      </span>
                    </>
                  )
                ) : (
                  <>
                    <span>Continue</span>{" "}
                    <span class="righ-arr">
                      {" "}
                      <FontAwesomeIcon icon={faArrowRight} />{" "}
                    </span>
                  </>
                )}
              </a>
            </div>
          </div>
            </div>
          </div>

        </div>
      </div>

      {showPopup && (

        <DilemaPop dilemma_popup={DilemmaPopup} onClose={() => setShowPopup(false)} />
        
      )}

    </div>
  );
}

export default Dilemma;
